import { CIcon } from '~/icons/types'

export const ciImage: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M19.35 1.5H4.65A3.15 3.15 0 0 0 1.5 4.65v14.7a3.15 3.15 0 0 0 3.15 3.15h14.7a3.15 3.15 0 0 0 3.15-3.15V4.65a3.15 3.15 0 0 0-3.15-3.15ZM4.4 7.36a2.79 2.79 0 1 1 5.469 1.108A2.79 2.79 0 0 1 4.4 7.36Zm16.26 9.94a3.36 3.36 0 0 1-3.36 3.36H4.81a.35.35 0 0 1-.25-.59L14 10.65a2 2 0 0 1 2.81 0l3.59 3.76c.19.2.297.464.3.74l-.04 2.15Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'image',
  type: 'solid'
}
